import { Button } from "@/components/ui/button";
import { useRouter } from "next/navigation";

const CTASection = () => {
  const router = useRouter();

  const navigateToSignup = () => {
    router.push('/signup');
  };

  return (
    <section className="py-20 bg-green-600 dark:bg-green-700 text-white">
      <div className="container mx-auto max-w-4xl px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-normal tracking-tight">
          Spend less time on calls. More time on food.
        </h2>
        <p className="mt-3 text-lg text-white/90">
          Start free, streamline operations, and grow with Menumate.
        </p>

        <div className="mt-8 flex justify-center">
          <Button
            size="lg"
            className="px-8 rounded-full bg-white text-green-700 hover:bg-white/90"
            onClick={navigateToSignup}
          >
            Start your free trial
          </Button>
        </div>

        <p className="mt-3 text-sm text-white/80">
          7-day free trial • No credit card required • Cancel anytime
        </p>
      </div>
    </section>
  );
};

export { CTASection };